export default __webpack_public_path__ + "4448f6213ad5162659d556ed3a786fc0.svg";